import React from 'react';
import ChecklistStatusBadge from './ChecklistStatusBadge';

const RecoveryChecklistPanel = ({ checklist, checklistType, onChangeChecklistType }) => {
  const items = Array.isArray(checklist?.items) ? checklist.items : [];

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-slate-100">Checklist Rollout</h3>
        <select
          value={checklistType}
          onChange={(e) => onChangeChecklistType?.(e.target.value)}
          className="h-8 rounded-md border border-slate-700 bg-slate-950 px-2 text-xs text-slate-200"
        >
          <option value="pre">Pre-Promotion</option>
          <option value="post">Post-Promotion</option>
          <option value="rollback">Rollback</option>
        </select>
      </div>

      <div className="space-y-2">
        {items.length ? items.map((item) => (
          <div key={item.id} className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-xs font-semibold text-slate-100">{item.label}</p>
              <ChecklistStatusBadge status={item.status} />
            </div>
            <p className="mt-1 text-xs text-slate-300">{item.message}</p>
            {item.metricValue !== undefined && item.metricValue !== null ? (
              <p className="mt-1 text-[11px] text-slate-500">Metric: {typeof item.metricValue === 'object' ? JSON.stringify(item.metricValue) : String(item.metricValue)}</p>
            ) : null}
          </div>
        )) : (
          <p className="rounded-lg border border-slate-800 bg-slate-950/70 p-3 text-xs text-slate-400">Checklist belum tersedia.</p>
        )}
      </div>
    </section>
  );
};

export default RecoveryChecklistPanel;
